import { axiosApi } from "shared/api/axios";
import { IPropsGetUsers } from "../model/usersTypes";

export const getUsers = async (params: IPropsGetUsers) => {
    const response = await axiosApi.get('/v1/users/user/', {params});
    return response.data;
};